export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/berita": [3],
		"/berita/[slug]": [4],
		"/direktorat-pkhl-2": [6],
		"/direktorat-pkhl": [5],
		"/disclaimer-ft": [7],
		"/dokumen-lainnya": [8],
		"/emisi-co2": [9],
		"/grafik-titik-panas": [10],
		"/hard-manggala-agni": [11],
		"/indikasi-luas-kebakaran": [12],
		"/laporan-harian-posko": [13],
		"/manggala-agni": [14],
		"/peraturan-perundangan": [15],
		"/peta": [16],
		"/privacy-policy": [17],
		"/sebaran-titik-panas": [18],
		"/struktur-organisasi": [19],
		"/survey-pengunjung": [20]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';